import { useTranslation } from "react-i18next";
import formatPrice from "@/core/helpers/formatPrice";
import { ClockIcon, RubleIcon } from "@/shared/icons";
import { EstateState } from "@/domains/estate/slice";
import getEstateImage from "@/domains/estate/helpers/getEstateImage";
import EstateBadge from "@/domains/estate/components/EstateBadge";
import EstateLockIcon from "@/domains/estate/components/EstateLockIcon";

type Props = {
  estate: EstateState["info"];
  isResidence: boolean;
};
export default function EstateView({ estate, isResidence }: Props) {
  const { t } = useTranslation("estate");

  const url = getEstateImage(estate, "medium");

  const paidDays = Math.floor(estate.feeBalance / estate.totalFee);

  return (
    <div
      className="relative isolate rounded-[0.875rem] h-[15rem] shrink-0 overflow-clip bg-dark-800"
      style={{
        backgroundImage: `url(${url})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <EstateLockIcon isLock={estate.isLocked} className="absolute top-2.5 left-2.5" />
      {isResidence && (
        <EstateBadge
          name="success"
          text={t("estate.residence")}
          className="absolute top-2.5 right-2.5 w-[6.6875rem]"
        />
      )}
      {estate.isSale ? (
        <div className="absolute flex items-center top-[2rem] -right-[3.5rem] h-[2.375rem] w-[13rem] py-1 bg-gradient-green rotate-45">
          <div className="h-full w-full flex item-center justify-center text-14 font-bold text-white uppercase border-t-2 border-b-2 border-dashed border-t-[#84FF97] border-b-[#84FF97]">
            {t("estate.sale")}
          </div>
        </div>
      ) : (
        <div className="absolute bottom-2.5 left-2.5 flex gap-1">
          <div className="h-14.5 leading-[0.75] flex items-center gap-2.5 px-3.5 bg-dark-900/60 rounded-[0.625rem] text-white backdrop-blur-[5px]">
            <RubleIcon size={20} className="shrink-0" />
            <div>
              <div className="text-16 font-bold">{formatPrice(estate.feeBalance)} ₽</div>
              <div className="text-15 font-medium mt-2">{t("estate.estateBalance")}</div>
            </div>
          </div>
          <div className="h-14.5 leading-[0.75] flex items-center gap-2.5 px-3.5 bg-dark-900/60 rounded-[0.625rem] text-white backdrop-blur-[5px]">
            <ClockIcon size={20} className="shrink-0" />
            <div>
              <div className="text-16 font-bold">{t("estate.days", { count: paidDays })}</div>
              <div className="text-15 font-medium mt-2">{t("estate.rent")}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
